// Recently opened records and pages, for the command palette's "Recent"
// group. A per-viewer convenience: kept in this browser only (localStorage,
// per user), capped at six, newest first. Storage can throw (private mode,
// blocked site data), so every access is guarded and the palette works
// without it.

const KEY = "nexusDialer.recent";
export const RECENT_LIMIT = 6;

const keyFor = (userId) => `${KEY}:${userId ?? "anon"}`;

export const readRecent = (userId) => {
  try {
    const raw = window.localStorage.getItem(keyFor(userId));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list)
      ? list.filter((item) => item?.path && item?.label)
      : [];
  } catch {
    return [];
  }
};

/** Put an entry first (deduplicated by path) and keep the newest six. */
export const pushRecent = (userId, entry) => {
  if (!entry?.path || !entry?.label) return;
  const next = [
    {
      path: entry.path,
      label: entry.label,
      kind: entry.kind || "Page",
      meta: entry.meta || "",
    },
    ...readRecent(userId).filter((item) => item.path !== entry.path),
  ].slice(0, RECENT_LIMIT);
  try {
    window.localStorage.setItem(keyFor(userId), JSON.stringify(next));
  } catch {
    /* convenience only */
  }
};

const RECORD_KINDS = {
  contacts: "Contact",
  deals: "Deal",
  companies: "Company",
  campaigns: "Campaign",
  calls: "Call",
  team: "Team",
};

/** The kind of record a detail path opens ("/contacts/42" → "Contact"), or null. */
export const recordKindFor = (pathname = "") => {
  const [section, id] = pathname.split("/").filter(Boolean);
  if (!id || id === "new") return null;
  return RECORD_KINDS[section] || null;
};
